export default {
  extractUuids: params => {
    return Array.from(params.entries())
      .filter(keyValuePair => keyValuePair[0].startsWith('uuids['))
      .map(keyValuePair => keyValuePair[1])
  }
}
